export default __webpack_public_path__ + "static/media/milestone 450.cd0b4a8b.svg";